import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import {ANALYTICS_CONSTANTS} from 'config';
import { HttpClientService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';

@Injectable()
export class FanDeploymentProfileService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
  private utilityService: UtilityService,
   private adobeAnalyticsService: AdobeAnalyticsService) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
       return test.body; })
      ,catchError( this.handleError ));
  }

  getFanDeploymentPageContent(profileId) {
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().singleFanProfileUrl;
    } else {
      url = this.utilityService.getEnvConfig().fanProfileUrl + '?profileid=' + profileId;
    }
     return this.fetchJSON(url);
  }

  setSelectedFan(fanId) {
    sessionStorage.setItem('selectedFAN', fanId);
  }

  getSelectedProfileID() {
    return sessionStorage.getItem('profileId');
  }

  handleError(error) {
    return throwError(error);
  }
createPageLoadProperties() {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_FAN_DEPLOYMENT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_DEVICE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = 'FanDeploymentProfile';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}

